module.exports = __webpack_public_path__ + "img/payFail.3f495b08.png";